import React from "react"
import ServiceItem from "../components/ServiceItem"
import { useStaticQuery, graphql } from "gatsby"

function Services() {
  const { allServicesYaml } = useStaticQuery(graphql`
    {
      allServicesYaml {
        edges {
          node {
            title
            src
            desc
          }
        }
      }
    }
  `)
  return (
    <div id = "services" className="container-fluid" style={{ backgroundColor: "#1A875D" }}>
      <div className="container">
        <div className="flexbox">
          <h1 className="text-center my-5">Skills</h1>
          <div className="row">
            {allServicesYaml.edges.map(({ node }) => {
              return <ServiceItem title={node.title} src={node.src} desc={node.desc} />
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Services
